import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { UserService } from '../services/user.service';
import { ToastService } from '../services/toast.service';
import { Router } from '@angular/router';
import { TAG_TOKEN, TAG_USERNAME, TAG_ROLE, TAG_MERCHANTCODE, TAG_DISTRIBUTORCODE, TAG_TRADENAME } from '../models/config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastService: ToastService,
    private router: Router
  ) {
    if (localStorage.getItem(TAG_TOKEN)) this.router.navigate(['home']);
  }

  form: FormGroup;

  ngOnInit(): void {
    // TODO: if token has value and still valid go to home
    this.form = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  onSubmit(): void {
    const username = this.form.controls.username.value;
    const password = this.form.controls.password.value;
    this.userService.login(username, password).subscribe(
      (result) => {
        const token = result;
        localStorage.setItem(TAG_TOKEN, token);
        this.userService.getById(username).subscribe((user) => {
          const distCode = user['merchant'] ? user['merchant']['distributorCode'] : ''
          const tradeName = user['merchant'] ? user['merchant']['tradeName'] : ''
          localStorage.setItem(TAG_USERNAME, user['username']);
          localStorage.setItem(TAG_MERCHANTCODE, user['merchantCode']);
          localStorage.setItem(TAG_DISTRIBUTORCODE, distCode);
          localStorage.setItem(TAG_TRADENAME, tradeName);
          localStorage.setItem(TAG_ROLE, user['roleId']);
          this.router.navigate(['home']);
        });
      },
      (err) => {
        console.log(err);
        this.toastService.showSuccess(JSON.parse(err.error).errors.join());
      }
    );
  }

  onForgotPassword(): void {
    this.router.navigate(['change-password','forgot'])
  }
}
